import { Line, ScanFields as ScanFieldsType } from '../types';
import { useValidatedSnItem } from '../hooks/useValidatedSnItem';

interface SerialNumberScannerProps {
  lines: Line[];
  scanFields: ScanFieldsType;
  onLinesUpdate: (lines: Line[]) => void;
  onScanFieldsUpdate: (fields: ScanFieldsType) => void;
}

export const useSerialNumberScanner = ({
  lines,
  scanFields,
  onLinesUpdate,
  onScanFieldsUpdate
}: SerialNumberScannerProps) => {
  
  const { fetchValidatedSnItem } = useValidatedSnItem();
  
  const scanSerialNumber = async (serialNumber: string) => {
    if (!scanFields.toSubinventory || !scanFields.toLocator) {
      alert(
        "Please select To Subinventory and To Locator before scanning serial numbers."
      );
      onScanFieldsUpdate({ ...scanFields, scanSerialNumber: "" });
      return;
    }

    const matchingLineIndex = lines.findIndex(
      (line) => line.serialNumber === serialNumber
    );

    if (matchingLineIndex !== -1) {
      const newLines = [...lines];
      const originalLine = newLines[matchingLineIndex];
      
      try {
        // Fetch validated serial item
        const validatedSerialItem = await fetchValidatedSnItem(serialNumber);
        
        const matchingLine = {
          ...originalLine,
          validatedSerialNumber: serialNumber,
          toSubinventory: scanFields.toSubinventory,
          toLocator: scanFields.toLocator,
          isSerialValid: true,
          validatedSerialItem: validatedSerialItem || ''
        };
        

        

        
        // Remove the matching line from its current position
        newLines.splice(matchingLineIndex, 1);
        // Add it to the top
        newLines.unshift(matchingLine);
        
        onLinesUpdate(newLines);
      } catch (error) {
        console.error('Error fetching validated serial item:', error);
        // Still update the line without validated serial item
        const matchingLine = {
          ...originalLine,
          validatedSerialNumber: serialNumber,
          toSubinventory: scanFields.toSubinventory,
          toLocator: scanFields.toLocator,
          isSerialValid: true
        };
        
        newLines.splice(matchingLineIndex, 1);
        newLines.unshift(matchingLine);
        onLinesUpdate(newLines);
      }
      
      onScanFieldsUpdate({ ...scanFields, scanSerialNumber: "" });
    } else {
      alert("Serial number not found in the current header lines.");
    }
  };

  return {
    scanSerialNumber
  };
};